export enum AgentRole {
  Admin = 'admin',
  Agent = 'agent',
  Owner = 'owner',
}
